export const config: any = {
    general: {
        minicartEnabled: true,
        quantity: {
            min: 1,
            max: 999
        },
        currency: {
            code: "EUR",
            symbol: "€",
            position: "after"
        },
        decimals: 2,
        roundingPrecision: 2,
        tax: {
            displayMode: "include",
            default: "standard",
            rates: {
                standard: 1.2
            },
            suffix: {
                visible: false,
                labels: {
                    include: "(incl. tax)",
                    exclude: "(excl. tax)"
                }
            }
        },
    },
    notices: {
        freeShipping: {
            visible: true,
            threshold: 0,
            emptyText: "You can get free shipping from %s",
            remainingText: "Only %s remains to free shipping",
            fullfilledText: "Congratulations, you have shipping for free!"
        },
        shippingInfo: []
    },
    links: {
        cart: {
            label: "Cart",
            url: "/cart"
        },
        checkout: {
            label: "Checkout",
            url: "/checkout"
        },
        shop: {
            label: "Go to shop",
            url: "/shop"
        }
    }
}

export const theme: any = {
    general: {
        sizingBase: 16,
        animations: true, // TODO
        transition: {
            duration: "400ms",
            timingFunction: "ease-in-out" 
        },
        mobileBreakpoint: 1024 
    }, 
    icons: {},
    components: {
        cartButton: {
            size: 3.125,
            paddingBlock: 0.25,
            paddingInline: 1,
            background: "#F98341",
            borderRadius: 0.625,
            borderColor: '#F98341',
						variant: 'icon-only', // filled, outlined, icon-only
            icon: {
                image: 'default', 
                position: 'left',
                fill: '#ffffff'
            },
						quantity: {
							textSize: 0.75,
							textColor: "#fff",
							background: "#333"
						},
            subtotal: {
								visibility: 'always', // always, on-hover
                textSize: 1.425,
                textColor: '#ffffff'
            }
        },
        sidebarHeader: {
            background: '#1d1d1b'
        }, 
        sidebarContent: {
            background: '#1d1d1b'
        }, 
        sidebarFooter: {
            background: '#1d1d1b',
            subtotal: {
                labelTextColor: '#333',
                subtotalTextColor: '#333'
            },
            notices: {
                shippingInfo: {
                    freeShippingText: {
                        textColor: '#333',
                        textSize: 0.75
                    },
                    progressBar: {
                        innerPadding: 0.25,
                        innerBackground: '#333',
                        outerBackground: '#EEEEEE',
                        height: 0.5,
                        borderRadius: 0.5
                    },
                    tooltipTrigger: {
                        iconColor: '#333',
                        background: '#F8F8F8',
                        borderRadius: 0,
                        size: 1.5
                    },
                    tooltipContent: {
                        textSize: 1,
                        headingColor: '#333',
                        descriptionColor: '#666',
                        originalPriceColor: '#444',
                        originalPriceBackground: '#ddd',
                        currentPriceColor: '#fff',
                        currentPriceBackground: '#666'
                    }
                }
            },
            actions: {
                button: {
                    borderWidth: 0.1,
                    borderRadius: 0.25,
                    borderColor: "#333",
                    background: "transparent",
                    textColor: "#333",
                    hoverBorderColor: "#fff",
                    hoverTextColor: "#fff",
                    hoverBackground: "#333", 
                    paddingBlock: 0.85,
                    paddingInline: 1.25,
                    cart: {
                        hoverBackground: "#F9834110"
                    },
                    checkout: {
                        background: "#333",
                        hoverBackground: "#333",
                        hoverBorderColor: "#333",
                        textColor: "#fff"
                    }
                }
            },
        }, 
        sidebarOverlay: {
            background: '#1d1d1b'
        }, 
        cartItem: {
            background: {
                default: 'transparent',
                hover: '#00000010'
            },
            image: {
                size: 4,
                borderRadius: 2,
            },
            name: {
                textColor: '#ffffff',
            },
            attributes: {
                textColor: '#888',
            },
            quantity: { 
                maxWidth: 5, 
                textColor: "#333",
                background: "transparent",
                borderWidth: 0.1,
                borderRadius: 0.0,
                borderColor: "#ddd",
                buttonTextColor: "#333",
                buttonBackground: "transparent",
                hoverButtonTextColor: "#fff",
                hoverButtonBackground: "#000", 
                borderColorHover: "#000"
            },  
            subtotal: {
                pricePerUnit: {
                    textColor: '#dddddd',
                    textSize: 3
                },
                subtotal: {
                    textColor: '#1d1d1b',
                    textSize: 4
                }
            }
        }
    }
};

export const translations: any = { 
    cartHeader: {
        title: "Cart"
    },
    cartFooter: {
        subtotal: "Subtotal"
    },
    cartEmpty: {
        title: "I feel so empty...",
        subtitle: "What about filling me with some good stuff, huh?",
    }
}